var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"page page-places",class:{
		'has-scrolled': _vm.hasScrolled,
	}},[_c('ChalkyUiPageHero',{attrs:{"description":"Thousands of verified spots to break and run.","title":"Find your Felt","imageUrl":_vm.$asset('image/fpo/pagehero-00.jpg')}}),_c('ScenePlaces',{ref:"scenePlaces",attrs:{"favoriteVenueCollection":_vm.favoriteVenueCollection,"nearbyVenueCollection":_vm.nearbyVenueCollection},on:{"venue:select":_vm.Handle_OnSelectVenue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }